export const environment = {
  production: true,
  microUiBasePath: '/shoppingcart/',
  microUiBasePathCoupon: '../ApplyDiscount',
  microUiBasePathBilling: '../BillingAndPayment',
  microUiBasePathOrderConfirmation: '../OrderConfirmation',
  microUiBasePathOrderSummary: '../OrderSummary',
  microUiBasePathProductDetails: '../ProductDetails',
  baseUrl: "https://api-nd.hrblock.com/2.2/w/",
  ndClientId: 'w-446637',
  adobeUrl: "//assets.adobedtm.com/launch-ENf8b881eaea0c427ab85c67d659962b81.min.js"
};

